<template>
    <div ref="headerContainer" class="header-wrapper" :class="{ hide: hideMenu }" :style="`--menu-scroll-progress: ${scrollY}`">
        <div class="static-header">
            <jump-transition>
                <div v-if="showBackArrow" class="back-button touch-reactive" @click="$emit('handleBack')">
                    <svg class="back-icon" viewBox="0 0 512 512" width="32" height="32"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M244 400L100 256l144-144M120 256h292"/></svg>
                </div>
            </jump-transition>
        </div>
        <div v-if="!hideMenu" class="profiles-menu">
            <div class="scroll-viewport">
                <div ref="menuContainer" class="profiles-container">
                    <div v-for="user in users" :key="user.id" :id="user.id" class="content">
                        <div class="profile flex-column-gap">
                            <div class="user-avatar" @click="clickInput(user)">
                                <avatar class="avatar" :userId="user.id" :avatar="user.base64avatar"></avatar>
                                <input style="display: none" type="file" id="selfie-header" capture="user" accept="image/*" @input="handleUploadAvatar"/>
                            </div>
                            <p v-parse-emojis class="name">{{ user.name }}</p>
                        </div>
                        <div v-if="user && user.statistics" class="statistics flex-column-gap">
                            <div class="line">
                                <p class="left">Spellen gespeeld</p>
                                <p class="right">{{ user.statistics.gamesPlayed || 0 }}</p>
                            </div>
                            <div class="line">
                                <p class="left">Rondes gewonnen</p>
                                <p class="right">{{ user.statistics.roundsWon || 0 }}</p>
                            </div>
                            <div class="line">
                                <p class="left">Aantal keer gepaald</p>
                                <p class="right">{{ user.statistics.impaled || 0 }}</p>
                            </div>
                            <div class="line">
                                <p class="left">Shotjes genomen</p>
                                <p class="right">{{ user.statistics.shotsTaken || 0 }}</p>
                            </div>
                            <div class="line">
                                <p class="left">Aantal keer JP 0</p>
                                <p class="right">{{ user.statistics.finishedWithZero || 0 }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="sticky-header">
            <div class="logo-container">
                <h1 class="logo" style="letter-spacing: 0;">JP</h1>
                <jump-transition>
                    <div v-if="!hideMenu" class="menu-handle" :class="{ active: scrolling || menuOpened }">
                        <div class="slide-line"></div>
                        <svg class="arrow-down" width="7" height="7" viewBox="0 0 512 512"><path d="M98 190.06l139.78 163.12a24 24 0 0036.44 0L414 190.06c13.34-15.57 2.28-39.62-18.22-39.62h-279.6c-20.5 0-31.56 24.05-18.18 39.62z"/></svg>
                    </div>
                </jump-transition>
            </div>
        </div>
    </div>
</template>

<script>
// import _ from 'lodash';
import { uploadAvatar } from '@/utils.js';

import JumpTransition from '@/components/transitions/JumpTransition.vue';
import Avatar from '@/components/Avatar.vue';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'

export default {
    name: 'menu-header',
    components: {
        JumpTransition,
        Avatar,
        Swiper,
        SwiperSlide
    },
    props: {
        hideMenu: {
            type: Boolean,
            default: false
        },
        sideMenuOpened: {
            type: Boolean,
            default: false
        },
        showBackArrow: {
            type: Boolean,
            default: false
        },
        users: {
            type: Array,
            default() { return [] }
        },
        view: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            menuScrollProgress: 0,
            scrollIteration: 0,
            scrollY: 0,
            scrolling: false,
            menuOpened: false,
            startingPositionY: 0,
            previousY: 0,
            speed: 0,
            startAnimation: null,
            scrollDeltaY: 0,
            toScroll: 0,
            menuToggled: false,
            disableMenuScrolling: false,
            you: null
        }
    },
    methods: {
        clickInput(user) {
            this.setYou();
            if(this.you?.id !== user.id) return

            document.getElementById('selfie-header').click();
        },
        async handleUploadAvatar(event) {
            const file = event.target.files[0];

            const avatar = await uploadAvatar(this.you.id, file);
            if(!avatar) return
            
            this.you.base64avatar = avatar;
            const stringify = JSON.stringify(this.you);
            localStorage.setItem('you', stringify);
        },
        handleTargetElement(event) {
            if(this.hideMenu) return

            const target = event.target;
            if(this.$refs.menuContainer.contains(target)) {
                this.scrolling = true;
                this.speed = 0;
            }
        },
        handlePageScroll(event) {
            if(this.disableMenuScrolling) return

            const touchEvent = event.targetTouches[0];
            const target = touchEvent.target;
            const positionY = touchEvent.clientY;
            if(!this.scrolling && !this.menuOpened && !this.$refs.headerContainer.contains(target)) return this.disableMenuScrolling = true

            if(!this.startingPositionY) this.startingPositionY = positionY;
            if(!this.toScroll) this.toScroll = this.menuOpened ? this.scrollY : 1 - this.scrollY;

            let speed = positionY - this.previousY;
            this.speed = speed;

            let relativeY = 0;
            if(this.menuOpened) relativeY = window.innerHeight - this.startingPositionY + positionY;
            else relativeY = positionY - this.startingPositionY;

            let deltaY = 0;
            if(!this.menuOpened) deltaY = (this.startingPositionY / window.innerHeight) * this.scrollY;

            this.scrolling = true;
            
            const step = relativeY / window.innerHeight + deltaY;
            let scrollPosition = step * this.toScroll;
            if(scrollPosition < 0) scrollPosition = 0;
            if(scrollPosition > 1) scrollPosition = 1;
            this.scrollY = scrollPosition;
            this.previousY = positionY;
        },
        updateScrollPosition(timestamp) {
            if(this.scrolling) return this.start = null;
            
            const duration = 800;
            if(!this.start) this.start = timestamp;
            var progress = timestamp - this.start;
            let x = progress/duration;
            if(x > 1) x = 1;
            if(x < 0) x = 0;
            const scrollY = this.scrollDeltaY;

            const newX = 1 - Math.pow(1 - x, 5);

            let updatedScrollY = 0;

            let speed = Math.max(Math.min(this.speed/30, 0.4), -0.4);
            const showSpeed = this.menuOpened ? speed < 0 : speed > 0;
            if(speed < 0) speed = speed * -1;
            const speedX = progress / (duration/2);
            const newSpeedX = 1 - Math.pow(1 - speedX, 5);
            let appliedSpeed = 0;
            if(newSpeedX <= 1 && !this.menuToggled && showSpeed) appliedSpeed = speed * Math.min(newSpeedX, 1-newSpeedX);

            if(this.menuOpened) updatedScrollY = this.scrollDeltaY + (newX*(1-scrollY)) - appliedSpeed;
            else updatedScrollY = this.scrollDeltaY - (newX*scrollY) + appliedSpeed;

            this.scrollY = updatedScrollY;

            if(x < 1) window.requestAnimationFrame(this.updateScrollPosition);
            else {
                this.start = null;
                this.menuToggled = false;
            }
        },
        async handleFinishScroll(menuOpened) {
            this.scrollDeltaY = this.scrollY;
            this.menuToggled = this.menuOpened !== menuOpened;
            this.menuOpened = menuOpened;
            window.requestAnimationFrame(this.updateScrollPosition);
        },
        handleUnfocus() {
            this.disableMenuScrolling = false;

            if(!this.scrolling) return

            this.scrolling = false;
            this.startingPositionY = 0;
            this.toScroll = 0;
            const speed = Math.max(Math.min(this.speed/30, 0.4), -0.4);

            const threshold = 0.5 - speed;
            if(this.scrollY > threshold) {
                this.handleFinishScroll(true);
            } else {
                this.handleFinishScroll(false);
            }
        },
        setYou() {
            const you = localStorage.getItem('you');
            if(!you) return;

            this.you = JSON.parse(you);
            this.scrollToMe();
        },
        async scrollToMe() {
            if (!this.you) return;

            const myIndex = this.users.findIndex(user => user?.id === this.you?.id);
            if(myIndex < 1) return;
            
            await this.$nextTick();
            const myContent = document.getElementById(this.you.id);
            myContent.scrollIntoView({ behavior: "smooth" });
        }
    },
    created() {
        this.setYou();
    },
    async mounted() {
        const vm = this;
        this.$root.$on('targetElement', vm.handleTargetElement);
        this.$root.$on('targetElementMoved', vm.handlePageScroll);
        this.$root.$on('clickElement', vm.handleUnfocus);
    },
    beforeDestroy() {
        const vm = this;
        this.$root.$off('targetElement', vm.handleTargetElement);
        this.$root.$off('targetElementMoved', vm.handlePageScroll);
        this.$root.$off('clickElement', vm.handleUnfocus);
    },
    watch: {
        'users.length': function() {
            this.setYou();
        },
        hideMenu: function() {
            if (this.hideMenu) return;

            this.setYou();
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';

.header-wrapper {
    width: 100%;
    min-height: 80px;
    max-height: 80px;

    &.hide .profiles-menu {
        pointer-events: none;
    }

    .profiles-menu {
        position: relative;
        max-width: var(--absolute-width);

        z-index: 201;

        &:after {
            content: "";
            position: absolute;
            inset: 0;
            background: #10150fdd;
            --border-radius: calc((1 - var(--menu-scroll-progress)) * 50%);
            border-radius: 0 0 var(--border-radius) var(--border-radius);
            z-index: -1;
        }

        .scroll-viewport {
            margin-top: calc((1 - var(--menu-scroll-progress)) * -100dvh);
            overflow-x: auto;
            scroll-snap-type: x mandatory;

            .profiles-container {
                display: flex;
    
                .content {
                    scroll-snap-align: center;
                    max-height: calc(100dvh - 80px);
                    min-height: calc(100dvh - 80px);
            
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 40px;

                    padding-top: 80px;
                    padding-inline: calc(var(--absolute-width) * 0.15);
                    min-width: calc(var(--absolute-width) * 0.7);
                    max-width: calc(var(--absolute-width) * 0.7);
                    z-index: 201;
            
                    .profile {
                        align-items: center;
            
                        .user-avatar {
                            width: 160px;
                            height: 160px;
                            border-radius: 50%;
                            overflow: hidden;
                            box-shadow: 0 8px 24px -8px #081808;
            
                            .avatar {
                                width: 160px;
                                height: 160px;
                                // object-fit: cover;
                            }
                            .default {
                                width: 160px;
                                height: 160px;
                                background-color: #78787839;
                            }
                        }
                        .name {
                            color: white;
                            text-align: center;
                            font-weight: 600;
                            font-size: 20px;
                        }
                        .about {
                            color: white;
                            text-align: center;
                            font-weight: 600;
                            font-size: 16px;
                        }
                    }
            
                    .statistics {
                        width: 100%;
            
                        .line {
                            display: flex;
                            justify-content: space-between;
                            color: white;
            
                            p {
                                text-shadow: 0 0 4px #00000099;
                            }
            
                            .left {
                                font-size: 16px;
                            }
                            .right {
                                font-size: 20px;
                                font-weight: 700;
                            }
                        }
                    }
            
                }
            }
        }


    }

    .static-header {
        --padding-inline: 32px;
        position: sticky;
        top: 0;
        margin-top: -80px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        color: $weed-green;
        height: 80px;
        width: calc(100% - (var(--padding-inline) * 2));
        padding-inline: var(--padding-inline);
        z-index: 200;

        &:before {
            content: "";
            position: absolute;
            top: 0;
            width: 100%;
            height: 80px;
            background: linear-gradient(180deg, #0b1c07 0%, #0b1c0700);
            z-index: -1;
        }

        .back-button {
            position: fixed;
            left: 28px;
            top: 40px;
            translate: 0 -50%;
            display: grid;
            place-items: center;

            .back-icon {
                color: #e2e2e2;
            }
        }

        .settings-button {
            position: fixed;
            right: 28px;
            top: 40px;
            translate: 0 -50%;
            display: grid;
            place-items: center;

            .settings-icon {
                color: #e2e2e2;

                rect {
                    transition: 400ms ease-in-out calc(var(--index) * 100ms);
                }
            }
        }

    }

    .sticky-header {
        position: sticky;
        top: 0;
        margin-top: -80px;
        display: grid;
        place-items: center;
        height: 80px;
        z-index: 205;
        pointer-events: none;
        
        .logo-container {
            display: grid;
            place-items: center;
            
            .logo {
                color: $weed-green;
                text-shadow: 2.2px 2.2px 0 #091103;
                font-size: 32px;
                animation: splash-header 700ms cubic-bezier(.7,.05,.31,.95);
            }
        
            .menu-handle {
                position: absolute;
                left: 50%;
                translate: -50% 0;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 1px;
                bottom: 9px;
        
                &.active {
                    .slide-line {
                        transition: .2s ease;
                        scale: 1.4;
                    }
                    .arrow-down {
                        transition: .2s ease;
                        scale: 0;
                    }
                }
        
                .slide-line {
                    width: 80px;
                    height: 2px;
                    background-color: #606d60ee;
                    border-radius: 2px;
                    transition: .4s ease .1s;
                    
                    // animation: slide-hint 6s ease-in-out infinite;
                }
                .arrow-down {
                    fill: #606d60ee;
                    transform: scaleX(5);
                    transition: .2s ease .1s;
                }
            }
        }
    }

}

.touch-reactive {
    position: relative;
    transition: .15s ease;

    &:after {
        content: "";
        position: absolute;
        inset: -25%;
        border-radius: 50%;
        background: #0911075f;
        z-index: -1;
        scale: 0;
        transition: .15s ease;
    }

    &.touch-active {
        scale: 0.9;

        &:after {
            scale: 1;
        }
    }
}

@keyframes splash-header {
    from {
        position: fixed;
        top: 50%;
        left: 50%;
        translate: -50% -50%;
        scale: 3.4;
        padding-top: 2px;
        z-index: 201;
    } to {
        position: fixed;
        top: 40px;
        left: 50%;
        translate: -50% -50%;
        padding-top: 0px;
        z-index: 201;
    }
}

@keyframes slide-hint {
    0%, 100% {
        transform: translateY(0);
    } 25% {
        transform: translateY(4px);
    }
}

</style>